webpackJsonp([7],{

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var Component = __webpack_require__(105)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(481),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4fb28d44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var Component = __webpack_require__(105)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(275),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0cdd8072",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    text: {
      type: [String, Number],
      default: '一颗小按钮'
    },
    inputType: {
      type: [String],
      default: 'button'
    },
    classStyle: {
      type: String,
      default: 'default-btn'
    }
  },
  methods: {
    btnClick: function btnClick(event) {
      this.$emit('btnClick', event);
    }
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(238)(true);
// imports


// module
exports.push([module.i, ".default-btn[data-v-0cdd8072],.disabled-btn[data-v-0cdd8072],.main-btn[data-v-0cdd8072],.warn-btn[data-v-0cdd8072]{width:100px;height:30px;line-height:28px;vertical-align:middle}input[data-v-0cdd8072]{display:inline-block;cursor:pointer;text-align:center}.gray-btn[data-v-0cdd8072]{border:1px solid #d5d5d5;color:#646464}.default-btn[data-v-0cdd8072]{border:1px solid #e1e1e1;border-radius:4px;font-size:12px;color:#646464;background-color:#f9f9f9;background-image:linear-gradient(180deg,#fff,#f9f9f9)}.default-btn[data-v-0cdd8072]:hover{background-color:#eee;background-image:linear-gradient(180deg,#f5f5f5,#eee)}.main-btn[data-v-0cdd8072]{border:1px solid #5c81e3;border-radius:4px;font-size:12px;color:#fff;background-color:#678ee7;background-image:linear-gradient(180deg,#678ee7,#5078df)}.main-btn[data-v-0cdd8072]:hover{background-color:#6c8cd4;background-image:linear-gradient(180deg,#6c8cd4,#4769c2)}.warn-btn[data-v-0cdd8072]{border:1px solid #d44d44;border-radius:4px;font-size:12px;color:#fff}.warn-btn[data-v-0cdd8072],.warn-btn[data-v-0cdd8072]:hover{background-color:#d44d44;background-image:linear-gradient(180deg,#d44d44,#d44d44)}.disabled-btn[data-v-0cdd8072]{cursor:not-allowed;border:1px solid #afafaf;border-radius:4px;font-size:12px;color:#fff;background-color:#a9a9a9;background-image:linear-gradient(180deg,#b8b8b8,#a9a9a9)}", "", {"version":3,"sources":["E:/成美/yshop-cmyy/xmall-front-master/src/components/YButton.vue"],"names":[],"mappings":"AAEA,mHACE,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,qBAAuB,CACxB,AACD,uBACE,qBAAsB,AACtB,eAAgB,AAChB,iBAAmB,CAOpB,AAGD,2BACE,yBAA0B,AAC1B,aAAe,CAChB,AACD,8BACE,yBAA0B,AAC1B,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,yBAA0B,AAC1B,qDAAyD,CAC1D,AACD,oCACI,sBAAuB,AACvB,qDAAyD,CAC5D,AACD,2BACE,yBAA0B,AAC1B,kBAAmB,AACnB,eAAgB,AAChB,WAAY,AACZ,yBAA0B,AAC1B,wDAA4D,CAC7D,AACD,iCACI,yBAA0B,AAC1B,wDAA4D,CAC/D,AACD,2BACE,yBAA0B,AAC1B,kBAAmB,AACnB,eAAgB,AAChB,UAAY,CAGb,AACD,4DAHE,yBAA0B,AAC1B,wDAA4D,CAK7D,AACD,+BACE,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,eAAgB,AAChB,WAAY,AACZ,yBAA0B,AAC1B,wDAA4D,CAC7D","file":"YButton.vue","sourcesContent":["\n@charset \"UTF-8\";\n.default-btn[data-v-0cdd8072], .main-btn[data-v-0cdd8072], .warn-btn[data-v-0cdd8072], .disabled-btn[data-v-0cdd8072] {\n  width: 100px;\n  height: 30px;\n  line-height: 28px;\n  vertical-align: middle;\n}\ninput[data-v-0cdd8072] {\n  display: inline-block;\n  cursor: pointer;\n  text-align: center;\n  /*> span {*/\n  /*user-select: none;*/\n  /*display: inline-block;*/\n  /*width: 100%;*/\n  /*height: 100%;*/\n  /*}*/\n}\n\n/*灰色的按钮*/\n.gray-btn[data-v-0cdd8072] {\n  border: 1px solid #d5d5d5;\n  color: #646464;\n}\n.default-btn[data-v-0cdd8072] {\n  border: 1px solid #e1e1e1;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #646464;\n  background-color: #f9f9f9;\n  background-image: linear-gradient(180deg, #fff, #f9f9f9);\n}\n.default-btn[data-v-0cdd8072]:hover {\n    background-color: #eee;\n    background-image: linear-gradient(180deg, #f5f5f5, #eee);\n}\n.main-btn[data-v-0cdd8072] {\n  border: 1px solid #5c81e3;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #fff;\n  background-color: #678ee7;\n  background-image: linear-gradient(180deg, #678ee7, #5078df);\n}\n.main-btn[data-v-0cdd8072]:hover {\n    background-color: #6c8cd4;\n    background-image: linear-gradient(180deg, #6c8cd4, #4769c2);\n}\n.warn-btn[data-v-0cdd8072] {\n  border: 1px solid #d44d44;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #fff;\n  background-color: #d44d44;\n  background-image: linear-gradient(180deg, #d44d44, #d44d44);\n}\n.warn-btn[data-v-0cdd8072]:hover {\n    background-color: #d44d44;\n    background-image: linear-gradient(180deg, #d44d44, #d44d44);\n}\n.disabled-btn[data-v-0cdd8072] {\n  cursor: not-allowed;\n  border: 1px solid #afafaf;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #fff;\n  background-color: #a9a9a9;\n  background-image: linear-gradient(180deg, #b8b8b8, #a9a9a9);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(273);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(239)("39ae8992", content, true, {});

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    class: _vm.classStyle,
    attrs: {
      "type": _vm.inputType,
      "readonly": "",
      "disabled": _vm.classStyle === 'disabled-btn'
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "click": function($event) {
        return _vm.btnClick($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title']
});

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(238)(true);
// imports


// module
exports.push([module.i, ".gray-box[data-v-3d864af4]{position:relative;margin-bottom:30px;overflow:hidden;background:#fff;border-radius:8px;border:1px solid #dcdcdc;border-color:rgba(0,0,0,.14);box-shadow:0 3px 8px -6px rgba(0,0,0,.1)}.gray-box .title[data-v-3d864af4]{padding-left:30px;position:relative;z-index:10;height:60px;padding:0 10px 0 24px;border-bottom:1px solid #d4d4d4;border-radius:8px 8px 0 0;box-shadow:0 1px 7px rgba(0,0,0,.06);background:#f3f3f3;background:linear-gradient(#fbfbfb,#ececec);line-height:60px;font-size:18px;color:#333;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}.gray-box .title h2[data-v-3d864af4]{font-size:18px;font-weight:400;color:#626262;display:inline-block}", "", {"version":3,"sources":["E:/成美/yshop-cmyy/xmall-front-master/src/components/shelf.vue"],"names":[],"mappings":"AACA,2BACE,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,yBAA0B,AAC1B,6BAAkC,AAClC,wCAA8C,CAC/C,AACD,kCACI,kBAAmB,AACnB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,gCAAiC,AACjC,0BAA2B,AAC3B,qCAA0C,AAC1C,mBAAoB,AACpB,4CAA8C,AAC9C,iBAAkB,AAClB,eAAgB,AAChB,WAAY,AACZ,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,8BAA+B,AACnC,sBAAuB,AACnB,kBAAoB,CAC3B,AACD,qCACM,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,oBAAsB,CAC3B","file":"shelf.vue","sourcesContent":["\n.gray-box[data-v-3d864af4] {\n  position: relative;\n  margin-bottom: 30px;\n  overflow: hidden;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #dcdcdc;\n  border-color: rgba(0, 0, 0, 0.14);\n  box-shadow: 0 3px 8px -6px rgba(0, 0, 0, 0.1);\n}\n.gray-box .title[data-v-3d864af4] {\n    padding-left: 30px;\n    position: relative;\n    z-index: 10;\n    height: 60px;\n    padding: 0 10px 0 24px;\n    border-bottom: 1px solid #d4d4d4;\n    border-radius: 8px 8px 0 0;\n    box-shadow: rgba(0, 0, 0, 0.06) 0 1px 7px;\n    background: #f3f3f3;\n    background: linear-gradient(#fbfbfb, #ececec);\n    line-height: 60px;\n    font-size: 18px;\n    color: #333;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.gray-box .title h2[data-v-3d864af4] {\n      font-size: 18px;\n      font-weight: 400;\n      color: #626262;\n      display: inline-block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(277);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(239)("48df409b", content, true, {});

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var Component = __webpack_require__(105)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(280),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d864af4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 280:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_vm._t("right")], 2)]), _vm._v(" "), _c('div', [_vm._t("content")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = cartAdd;
/* unused harmony export cartCount */
/* harmony export (immutable) */ __webpack_exports__["b"] = cartDel;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartList;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartUpdate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(106);
/**
 * 购物车接口封装
 */


// 添加到购物车
function cartAdd(data) {
    // {
    //     "bargainId": 0, 产品砍价ID
    //     "cartNum": 0, 购物车数量
    //     "combinationId": 0, 产品拼团ID
    //     "new": 0, 是否新购买
    //     "productId": 0, 产品ID
    //     "secKillId": 0, 产品秒杀ID
    //     "uniqueId": "" 唯一的ID
    // }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
        url: '/cart/add',
        method: 'post',
        data: data
    });
}

// 获取数量
function cartCount() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
        url: '/cart/count',
        method: 'get'
    });
}

// 删除购物车产品
function cartDel(data) {
    // {
    //     "ids": [] 购物车ID，多个用,分隔开
    // }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
        url: '/cart/del',
        method: 'post',
        data: data
    });
}

// 获取购物车列表
function cartList() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
        url: '/cart/list',
        method: 'get'
    });
}

// 更新购物车
function cartUpdate(data) {
    // {
    //     "id": 0, 购物车ID
    //     "number": 0  购物车数量
    // }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
        url: '/cart/num',
        method: 'post',
        data: data
    });
}

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getHomeData;
/* harmony export (immutable) */ __webpack_exports__["a"] = getKeyWord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(106);


function getHomeData() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
    url: '/pc/home',
    method: 'get'
  });
}

// 热门搜索关键字获取
function getKeyWord() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
    url: '/search/keyword',
    method: 'get'
  });
}

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_YButton__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_YButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_YButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_cart__ = __webpack_require__(281);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    msg: {
      salePrice: 0
    }
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']), {
    goodsDetails: function goodsDetails(id) {
      if (this.login) {
        // 登录了，直接跳转详情页面
        this.$router.push({ path: 'goodsDetails/productId=' + id });
      } else {
        this.$router.push({
          path: '/login'
        });
      }
    },
    openProduct: function openProduct(id) {
      if (this.login) {
        // 登录了，直接跳转详情页面
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id);
      } else {
        this.$router.push({
          path: '/login'
        });
      }
    },
    addCart: function addCart(msg) {
      var _this = this;

      if (!this.showMoveImg) {
        // 动画是否在运动
        var unique = msg.productValue[msg.productAttr[0].attrValue[0].attr].unique;
        var sku = msg.productValue[msg.productAttr[0].attrValue[0].attr].sku;
        console.log('sku--->', sku);
        if (this.login) {
          // 登录了 直接存在用户名下
          var params = {
            productId: msg.id,
            cartNum: 1,
            secKillId: 0,
            uniqueId: unique
          };

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_cart__["c" /* cartAdd */])(params).then(function (res) {
            // 并不重新请求数据
            if (res.status === 200) {
              _this.ADD_CART({
                id: res.data.cartId,
                productId: msg.id,
                salePrice: msg.price,
                productName: msg.storeName,
                productImg: msg.image,
                productNum: 1,
                secKillId: 0,
                uniqueId: unique,
                sku: sku
              });
            } else {
              _this.$message.warning(res.msg);
            }
          });

          // addCart({userId: getStore('userId'), productId: id, productNum: 1}).then(res => {
          //   // 并不重新请求数据
          //   this.ADD_CART({productId: id, salePrice: price, productName: name, productImg: img})
          // })
        } else {
          // 未登录 vuex
          this.ADD_CART({
            productId: msg.id,
            salePrice: msg.price,
            productName: msg.storeName,
            productImg: msg.image,
            productNum: 1,
            secKillId: 0,
            uniqueId: unique,
            sku: sku
          });
          // this.ADD_CART({productId: id, salePrice: price, productName: name, productImg: img})
        }
        // 加入购物车动画
        var dom = event.target;
        // 获取点击的坐标
        var elLeft = dom.getBoundingClientRect().left + dom.offsetWidth / 2;
        var elTop = dom.getBoundingClientRect().top + dom.offsetHeight / 2;
        // 需要触发
        this.ADD_ANIMATION({ moveShow: true, elLeft: elLeft, elTop: elTop, img: msg.image });
        if (!this.showCart) {
          this.SHOW_CART({ showCart: true });
        }
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['login', 'showMoveImg', 'showCart'])),
  mounted: function mounted() {},

  components: {
    YButton: __WEBPACK_IMPORTED_MODULE_1__components_YButton___default.a
  }
});

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(238)(true);
// imports


// module
exports.push([module.i, ".good-item .ds[data-v-0d644bfe]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.good-item[data-v-0d644bfe]{background:#fff;width:25%;transition:all .5s;height:400px}.good-item[data-v-0d644bfe]:hover{transform:translateY(-3px);box-shadow:1px 1px 20px #999}.good-item:hover .good-price p[data-v-0d644bfe]{display:none}.good-item:hover .ds[data-v-0d644bfe]{display:-ms-flexbox;display:flex}.good-item .ds[data-v-0d644bfe]{width:100%;display:none}.good-item .good-img img[data-v-0d644bfe]{margin:50px auto 10px;width:206px;height:206px;display:block}.good-item .good-price[data-v-0d644bfe]{margin:15px 0;height:30px;text-align:center;line-height:30px;color:#d44d44;font-family:Arial;font-size:18px;font-weight:700}.good-item .good-title[data-v-0d644bfe]{line-height:1.2;font-size:16px;color:#424242;margin:0 auto;padding:0 14px;text-align:center;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.good-item h3[data-v-0d644bfe]{text-align:center;line-height:1.2;font-size:12px;color:#d0d0d0;padding:10px}.collect[data-v-0d644bfe]{position:absolute;top:0;right:0}.collect-img[data-v-0d644bfe]{position:absolute;top:-50px;left:-25px}", "", {"version":3,"sources":["E:/成美/yshop-cmyy/xmall-front-master/src/components/mallGoods.vue"],"names":[],"mappings":"AACA,gCACE,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AACxB,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,4BACE,gBAAiB,AACjB,UAAW,AACX,mBAAoB,AACpB,YAAc,CACf,AACD,kCACI,2BAA4B,AAC5B,4BAA8B,CACjC,AACD,gDACM,YAAc,CACnB,AACD,sCACM,oBAAqB,AACrB,YAAc,CACnB,AACD,gCACI,WAAY,AACZ,YAAc,CACjB,AACD,0CACI,sBAAuB,AACvB,YAAa,AACb,aAAc,AACd,aAAe,CAClB,AACD,wCACI,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,iBAAkB,AAClB,cAAe,AACf,kBAAmB,AACnB,eAAgB,AAChB,eAAiB,CACpB,AACD,wCACI,gBAAiB,AACjB,eAAgB,AAChB,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,mBAAoB,AACpB,sBAAwB,CAC3B,AACD,+BACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,cAAe,AACf,YAAc,CACjB,AACD,0BACE,kBAAmB,AACnB,MAAS,AACT,OAAW,CACZ,AACD,8BACE,kBAAmB,AACnB,UAAW,AACX,UAAY,CACb","file":"mallGoods.vue","sourcesContent":["\n.good-item .ds[data-v-0d644bfe] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.good-item[data-v-0d644bfe] {\n  background: #fff;\n  width: 25%;\n  transition: all .5s;\n  height: 400px;\n}\n.good-item[data-v-0d644bfe]:hover {\n    transform: translateY(-3px);\n    box-shadow: 1px 1px 20px #999;\n}\n.good-item:hover .good-price p[data-v-0d644bfe] {\n      display: none;\n}\n.good-item:hover .ds[data-v-0d644bfe] {\n      display: -ms-flexbox;\n      display: flex;\n}\n.good-item .ds[data-v-0d644bfe] {\n    width: 100%;\n    display: none;\n}\n.good-item .good-img img[data-v-0d644bfe] {\n    margin: 50px auto 10px;\n    width: 206px;\n    height: 206px;\n    display: block;\n}\n.good-item .good-price[data-v-0d644bfe] {\n    margin: 15px 0;\n    height: 30px;\n    text-align: center;\n    line-height: 30px;\n    color: #d44d44;\n    font-family: Arial;\n    font-size: 18px;\n    font-weight: 700;\n}\n.good-item .good-title[data-v-0d644bfe] {\n    line-height: 1.2;\n    font-size: 16px;\n    color: #424242;\n    margin: 0 auto;\n    padding: 0 14px;\n    text-align: center;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n.good-item h3[data-v-0d644bfe] {\n    text-align: center;\n    line-height: 1.2;\n    font-size: 12px;\n    color: #d0d0d0;\n    padding: 10px;\n}\n.collect[data-v-0d644bfe] {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n}\n.collect-img[data-v-0d644bfe] {\n  position: absolute;\n  top: -50px;\n  left: -25px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(297);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(239)("277e1c30", content, true, {});

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var Component = __webpack_require__(105)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(300),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d644bfe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 300:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "good-item"
  }, [_c('div', {}, [_c('div', {
    staticClass: "good-img"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openProduct(_vm.msg.id)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.msg.image),
      expression: "msg.image"
    }],
    key: _vm.msg.image,
    attrs: {
      "alt": _vm.msg.storeName
    }
  })])]), _vm._v(" "), _c('h6', {
    staticClass: "good-title",
    domProps: {
      "innerHTML": _vm._s(_vm.msg.storeName)
    }
  }, [_vm._v(_vm._s(_vm.msg.storeName))]), _vm._v(" "), _c('div', {
    staticClass: "good-price pr"
  }, [_c('div', {
    staticClass: "ds pa"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openProduct(_vm.msg.id)
      }
    }
  }, [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "查看详情"
    }
  })], 1), _vm._v(" "), _c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "加入购物车",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": function($event) {
        return _vm.addCart(_vm.msg)
      }
    }
  })], 1), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.msg.price) + "\n          "), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#999",
      "text-decoration": "line-through",
      "font-weight": "400"
    }
  }, [_vm._v("￥" + _vm._s(_vm.msg.otPrice))])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['product']
});

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(238)(true);
// imports


// module
exports.push([module.i, ".item .img-box[data-v-50f5bdcb]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.item[data-v-50f5bdcb]{position:relative;height:429px;text-align:center}.item img[data-v-50f5bdcb]{display:block;width:206px;height:206px}.item .info[data-v-50f5bdcb]{width:100%;padding:0 10px}.item .info h6[data-v-50f5bdcb]{font-size:16px;color:#424242}.item .info h6[data-v-50f5bdcb],.item .info p[data-v-50f5bdcb]{overflow:hidden;line-height:1.2;white-space:nowrap;text-overflow:ellipsis}.item .info p[data-v-50f5bdcb]{padding-top:7px;font-size:12px;color:#b2b2b2}", "", {"version":3,"sources":["E:/成美/yshop-cmyy/xmall-front-master/src/components/product.vue"],"names":[],"mappings":"AACA,gCACE,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AACxB,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,uBACE,kBAAmB,AACnB,aAAc,AACd,iBAAmB,CACpB,AACD,2BACI,cAAe,AACf,YAAa,AACb,YAAc,CACjB,AACD,6BACI,WAAY,AACZ,cAAgB,CACnB,AACD,gCAEM,eAAgB,AAIhB,aAAe,CACpB,AACD,+DAPM,gBAAiB,AAEjB,gBAAiB,AACjB,mBAAoB,AACpB,sBAAwB,CAW7B,AARD,+BAEM,gBAAiB,AACjB,eAAgB,AAIhB,aAAe,CACpB","file":"product.vue","sourcesContent":["\n.item .img-box[data-v-50f5bdcb] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.item[data-v-50f5bdcb] {\n  position: relative;\n  height: 429px;\n  text-align: center;\n}\n.item img[data-v-50f5bdcb] {\n    display: block;\n    width: 206px;\n    height: 206px;\n}\n.item .info[data-v-50f5bdcb] {\n    width: 100%;\n    padding: 0 10px;\n}\n.item .info h6[data-v-50f5bdcb] {\n      overflow: hidden;\n      font-size: 16px;\n      line-height: 1.2;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      color: #424242;\n}\n.item .info p[data-v-50f5bdcb] {\n      overflow: hidden;\n      padding-top: 7px;\n      font-size: 12px;\n      line-height: 1.2;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      color: #b2b2b2;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(347);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(239)("6d3ada08", content, true, {});

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var Component = __webpack_require__(105)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(355),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50f5bdcb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 355:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "product.spu.id"
    }
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.spu.sku_info[0].ali_image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h6', {
    staticClass: "ellipsis"
  }, [_vm._v(_vm._s(_vm.product.spu.sku_info[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.spu.sku_info[0].sub_title))])]), _vm._v(" "), _c('p', {
    staticClass: "price"
  }, [_c('i', [_vm._v("¥")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.product.spu.price))])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "dot-list"
  }, [_c('li')])
}]}

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shelf__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shelf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shelf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mallGoods__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mallGoods___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_mallGoods__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_storage_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_home__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(107);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      error: false,
      mark: 0,
      bgOpt: {
        px: 0,
        py: 0,
        w: 0,
        h: 0
      },
      home: [],
      loading: true,
      notify: '1',
      dialogVisible: false,
      timer: '',
      bannerList: [],
      // 活动专区
      actList: [],
      // 健康专区
      healthList: [],
      headHealthList: [],
      // 热门榜单
      likeInfo: [],
      // 精品推荐
      bastList: [],
      // 为您推荐
      benefit: [],
      bastFirst: {},
      areaList: []
    };
  },

  methods: {
    autoPlay: function autoPlay() {
      this.mark++;
      if (this.mark > this.bannerList.length - 1) {
        // 当遍历到最后一张图片置零
        this.mark = 0;
      }
    },
    play: function play() {
      // 每2.5s自动切换
      this.timer = setInterval(this.autoPlay, 2500);
    },
    change: function change(i) {
      this.mark = i;
    },
    startTimer: function startTimer() {
      this.timer = setInterval(this.autoPlay, 2500);
    },
    stopTimer: function stopTimer() {
      clearInterval(this.timer);
    },
    linkTo: function linkTo(item) {
      if (this.login) {
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + item.id);
      } else {
        // 未登录，跳转到登录页面
        this.$router.push({
          path: '/login'
        });
      }
    },
    onBannerClick: function onBannerClick(item) {
      if (!this.login) {
        // 未登录，跳转到登录页面
        this.$router.push({
          path: '/login'
        });
        return;
      }
      switch (item.type) {
        case 0:
          // 商品详情跳转
          this.$router.push({
            path: '/goodsDetails',
            query: {
              productId: item.turnId
            }
          });
          break;
        case 1:
          // 分类跳转
          break;
        case 2:
          // 新闻跳转
          break;
      }

      // 完整链接
      // window.location.href = item.fullUrl
    },
    bgOver: function bgOver(e) {
      this.bgOpt.px = e.offsetLeft;
      this.bgOpt.py = e.offsetTop;
      this.bgOpt.w = e.offsetWidth;
      this.bgOpt.h = e.offsetHeight;
    },
    bgMove: function bgMove(dom, eve) {
      var bgOpt = this.bgOpt;
      var X = void 0,
          Y = void 0;
      var mouseX = eve.pageX - bgOpt.px;
      var mouseY = eve.pageY - bgOpt.py;
      if (mouseX > bgOpt.w / 2) {
        X = mouseX - bgOpt.w / 2;
      } else {
        X = mouseX - bgOpt.w / 2;
      }
      if (mouseY > bgOpt.h / 2) {
        Y = bgOpt.h / 2 - mouseY;
      } else {
        Y = bgOpt.h / 2 - mouseY;
      }
      dom.style['transform'] = 'rotateY(' + X / 50 + 'deg) rotateX(' + Y / 50 + 'deg)';
      dom.style.transform = 'rotateY(' + X / 50 + 'deg) rotateX(' + Y / 50 + 'deg)';
    },
    bgOut: function bgOut(dom) {
      dom.style['transform'] = 'rotateY(0deg) rotateX(0deg)';
      dom.style.transform = 'rotateY(0deg) rotateX(0deg)';
    },
    showNotify: function showNotify() {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_storage_js__["a" /* getStore */])('notify');
      if (this.notify !== value) {
        // this.dialogVisible = true
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_storage_js__["b" /* setStore */])('notify', this.notify);
      }
    },
    onMore: function onMore(type) {
      window.open('//' + window.location.host + '/#/moregoods?type=' + type);
      /* this.$router.push({
         path: '/moregoods',
         query: {
           type: type
         }
       }) */
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var _this = this;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_home__["b" /* getHomeData */])().then(function (res) {
      _this2.loading = false;
      _this.bannerList = res.data.banner;
      _this.actList = res.data.actList;
      _this.healthList = res.data.healthList;
      if (_this.healthList.length > 3) {
        _this.headHealthList = res.data.healthList.slice(0, 4);
      }
      _this.likeInfo = res.data.likeInfo;
      _this.bastList = res.data.bastList;
      _this.benefit = res.data.benefit;
      _this.areaList = res.data.ads;
      _this.bastFirst = _this.bastList[0];
      _this.bastList.shift();
      /* if (res.success === false) {
        this.error = true
        return
      }
      let data = res.result
      this.home = data
      this.loading = false
      for (let i = 0; i < data.length; i++) {
        if (data[i].type === 0) {
          this.banner = data[i].panelContents
        }
      } */
    });
    this.showNotify();
  },
  created: function created() {
    this.play();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])(['login'])),

  components: {
    YShelf: __WEBPACK_IMPORTED_MODULE_1__components_shelf___default.a,
    product: __WEBPACK_IMPORTED_MODULE_2__components_product___default.a,
    mallGoods: __WEBPACK_IMPORTED_MODULE_3__components_mallGoods___default.a
  }
});

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(238)(true);
// imports


// module
exports.push([module.i, ".home[data-v-4fb28d44],.no-info[data-v-4fb28d44]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.no-info[data-v-4fb28d44]{padding:100px 0;text-align:center;font-size:30px}.no-info .no-data[data-v-4fb28d44]{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center}.fade-enter-active[data-v-4fb28d44],.fade-leave-active[data-v-4fb28d44]{transition:opacity .5s}.fade-enter[data-v-4fb28d44],.fade-leave-to[data-v-4fb28d44]{opacity:0}.page[data-v-4fb28d44]{position:absolute;width:100%;top:470px;z-index:30}.page .dots[data-v-4fb28d44]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.page .dots .dot-active[data-v-4fb28d44]{display:inline-block;width:15px;height:15px;background-color:#1da377;border-radius:8px;margin-right:10px;cursor:pointer}.page .dots .dot[data-v-4fb28d44]{opacity:.2}.activity-panel[data-v-4fb28d44]{width:1220px;margin:0 auto}.activity-panel .box[data-v-4fb28d44]{overflow:hidden;position:relative;z-index:0;margin-top:25px;box-sizing:border-box;border:1px solid rgba(0,0,0,.14);border-radius:8px;background:#fff;box-shadow:0 3px 8px -6px rgba(0,0,0,.1)}.activity-panel .content[data-v-4fb28d44]{float:left;position:relative;box-sizing:border-box;width:25%;height:230px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;text-align:center}.activity-panel .content[data-v-4fb28d44] :before{position:absolute;top:0;left:0;z-index:1;box-sizing:border-box;border-left:1px solid #f2f2f2;border-left:1px solid rgba(0,0,0,.1);width:100%;height:100%;content:\"\";pointer-events:none}.activity-panel .i[data-v-4fb28d44]{height:200px}.activity-panel .cover-link[data-v-4fb28d44]{cursor:pointer;display:block;position:absolute;top:0;right:0;bottom:0;left:0;z-index:4;background:url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat}.activity-panel a[data-v-4fb28d44]{color:#5079d9;cursor:pointer;transition:all .15s ease-out;text-decoration:none}.activity-panel a[data-v-4fb28d44]:hover{box-shadow:inset 0 0 38px rgba(0,0,0,.08);transition:all .15s ease}.banner[data-v-4fb28d44],.banner div[data-v-4fb28d44],.banner span[data-v-4fb28d44]{font-family:Microsoft YaHei;transition:all .3s;transition-timing-function:linear}.banner[data-v-4fb28d44]{cursor:pointer;perspective:3000px;position:relative;z-index:19;margin:0 auto;width:1220px}.bg[data-v-4fb28d44]{position:relative;width:1220px;height:500px;margin:20px auto;background-size:100% 100%;border-radius:10px;transform-style:preserve-3d;transform-origin:50% 50%;transform:rotateY(0deg) rotateX(0deg)}.bg div[data-v-4fb28d44]{position:relative;height:100%;width:100%}.img1[data-v-4fb28d44]{top:0}.img1[data-v-4fb28d44],.img2[data-v-4fb28d44]{display:block;position:absolute;width:100%;height:100%;border-radius:10px}.img2[data-v-4fb28d44]{bottom:5px;left:0;background-size:95% 100%}.img3[data-v-4fb28d44]{display:block;position:absolute;width:100%;height:100%;top:0;border-radius:10px}.a[data-v-4fb28d44]{z-index:20;transform:translateZ(40px)}.b[data-v-4fb28d44]{z-index:20;transform:translateZ(30px)}.c[data-v-4fb28d44]{transform:translateZ(0)}.sk_item[data-v-4fb28d44]{width:170px;height:225px;padding:0 14px 0 15px}.sk_item>div[data-v-4fb28d44]{width:100%}.sk_item a[data-v-4fb28d44]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;transition:all .3s}.sk_item a[data-v-4fb28d44]:hover{transform:translateY(-5px)}.sk_item img[data-v-4fb28d44]{width:130px;height:130px;margin:17px 0}.sk_item .sk_item_name[data-v-4fb28d44]{color:#999;display:block;max-width:100%;_width:100%;overflow:hidden;font-size:12px;text-align:left;height:32px;line-height:16px;word-wrap:break-word;word-break:break-all}.sk_item .sk_item_price[data-v-4fb28d44]{padding:3px 0;height:25px}.sk_item .price_new[data-v-4fb28d44]{font-size:18px;font-weight:700;margin-right:8px;color:#f10214}.sk_item .price_origin[data-v-4fb28d44]{color:#999;font-size:12px}.box[data-v-4fb28d44]{overflow:hidden;position:relative;z-index:0;margin-top:29px;box-sizing:border-box;border:1px solid rgba(0,0,0,.14);border-radius:8px;background:#fff;box-shadow:0 3px 8px -6px rgba(0,0,0,.1)}ul.box[data-v-4fb28d44]{display:-ms-flexbox;display:flex}ul.box li[data-v-4fb28d44]{-ms-flex:1;flex:1}ul.box li img[data-v-4fb28d44]{display:block;height:200px}.mt30[data-v-4fb28d44]{margin-top:30px}.hot[data-v-4fb28d44]{display:-ms-flexbox;display:flex}.hot>div[data-v-4fb28d44]{-ms-flex:1;flex:1;width:25%}.floors[data-v-4fb28d44]{width:100%;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center}.floors .imgbanner[data-v-4fb28d44]{width:50%;height:430px}.floors .imgbanner .cover-link[data-v-4fb28d44]{cursor:pointer;display:block;position:absolute;top:60px;left:0;width:50%;height:430px;z-index:4;background:url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat}.floors .imgbanner .cover-link[data-v-4fb28d44]:hover{box-shadow:inset 0 0 38px rgba(0,0,0,.08);transition:all .15s ease}.floors img[data-v-4fb28d44]{display:block;width:100%;height:100%}.more[data-v-4fb28d44]{color:#5078df;font-size:16px;cursor:pointer}", "", {"version":3,"sources":["E:/成美/yshop-cmyy/xmall-front-master/src/page/Home/home.vue"],"names":[],"mappings":"AAOA,iDALE,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,qBAAuB,CAU5B,AARD,0BACE,gBAAiB,AACjB,kBAAmB,AACnB,cAAgB,CAKjB,AACD,mCACI,2BAA4B,AACxB,0BAA2B,AAC3B,iBAAmB,CAC1B,AACD,wEACE,sBAAwB,CACzB,AACD,6DACE,SAAW,CACZ,AACD,uBACE,kBAAmB,AACnB,WAAY,AACZ,UAAW,AACX,UAAY,CACb,AACD,6BACI,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,mBAAoB,AACxB,sBAAuB,AACnB,mBAAoB,AACxB,qBAAsB,AAClB,sBAAwB,CAC/B,AACD,yCACM,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,kBAAmB,AACnB,cAAgB,CACrB,AACD,kCACM,UAAa,CAClB,AACD,iCACE,aAAc,AACd,aAAe,CAChB,AACD,sCACI,gBAAiB,AACjB,kBAAmB,AACnB,UAAW,AACX,gBAAiB,AACjB,sBAAuB,AACvB,iCAAsC,AACtC,kBAAmB,AACnB,gBAAiB,AACjB,wCAA8C,CACjD,AACD,0CACI,WAAY,AACZ,kBAAmB,AACnB,sBAAuB,AACvB,UAAW,AACX,aAAc,AACd,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,mBAAoB,AACxB,iBAAmB,CACtB,AACD,kDACI,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,UAAW,AACX,sBAAuB,AACvB,8BAA+B,AAC/B,qCAA0C,AAC1C,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,mBAAqB,CACxB,AACD,oCACI,YAAc,CACjB,AACD,6CACI,eAAgB,AAChB,cAAe,AACf,kBAAmB,AACnB,MAAO,AACP,QAAS,AACT,SAAU,AACV,OAAQ,AACR,UAAW,AACX,yGAA2G,CAC9G,AACD,mCACI,cAAe,AACf,eAAgB,AAChB,6BAA8B,AAC9B,oBAAsB,CACzB,AACD,yCACI,0CAA+C,AAC/C,wBAA0B,CAC7B,AACD,oFACE,4BAA+B,AAC/B,mBAAoB,AACpB,iCAAmC,CACpC,AACD,yBACE,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,WAAY,AACZ,cAAe,AACf,YAAc,CACf,AACD,qBACE,kBAAmB,AACnB,aAAc,AACd,aAAc,AACd,iBAAkB,AAClB,0BAA2B,AAC3B,mBAAoB,AACpB,4BAA6B,AAC7B,yBAA0B,AAC1B,qCAAuC,CACxC,AACD,yBACI,kBAAmB,AACnB,YAAa,AACb,UAAY,CACf,AACD,uBAKE,KAAO,CAER,AACD,8CAPE,cAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,YAAa,AAEb,kBAAoB,CAWrB,AATD,uBAKE,WAAY,AACZ,OAAQ,AACR,wBAA0B,CAE3B,AACD,uBACE,cAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,MAAO,AACP,kBAAoB,CACrB,AACD,oBACE,WAAY,AACZ,0BAA4B,CAC7B,AACD,oBACE,WAAY,AACZ,0BAA4B,CAC7B,AACD,oBACE,uBAA2B,CAC5B,AACD,0BACE,YAAa,AACb,aAAc,AACd,qBAAuB,CACxB,AACD,8BACI,UAAY,CACf,AACD,4BACI,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,sBAAuB,AAC3B,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,mBAAoB,AACxB,kBAAoB,CACvB,AACD,kCACM,0BAA4B,CACjC,AACD,8BACI,YAAa,AACb,aAAc,AACd,aAAe,CAClB,AACD,wCACI,WAAY,AACZ,cAAe,AACf,eAAgB,CAChB,WAAa,AACb,gBAAiB,AACjB,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,iBAAkB,AAClB,qBAAsB,AACtB,oBAAsB,CACzB,AACD,yCACI,cAAe,AACf,WAAa,CAChB,AACD,qCACI,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,aAAe,CAClB,AACD,wCACI,WAAY,AACZ,cAAgB,CACnB,AACD,sBACE,gBAAiB,AACjB,kBAAmB,AACnB,UAAW,AACX,gBAAiB,AACjB,sBAAuB,AACvB,iCAAsC,AACtC,kBAAmB,AACnB,gBAAiB,AACjB,wCAA8C,CAC/C,AACD,wBACE,oBAAqB,AACrB,YAAc,CACf,AACD,2BACI,WAAY,AACR,MAAQ,CACf,AACD,+BACM,cAAe,AACf,YAAc,CACnB,AACD,uBACE,eAAiB,CAClB,AACD,sBACE,oBAAqB,AACrB,YAAc,CACf,AACD,0BACI,WAAY,AACR,OAAQ,AACZ,SAAW,CACd,AACD,yBACE,WAAY,AACZ,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,sBAAuB,AACnB,kBAAoB,CACzB,AACD,oCACI,UAAW,AACX,YAAc,CACjB,AACD,gDACM,eAAgB,AAChB,cAAe,AACf,kBAAmB,AACnB,SAAU,AACV,OAAQ,AACR,UAAW,AACX,aAAc,AACd,UAAW,AACX,yGAA2G,CAChH,AACD,sDACM,0CAA+C,AAC/C,wBAA0B,CAC/B,AACD,6BACI,cAAe,AACf,WAAY,AACZ,WAAa,CAChB,AACD,uBACE,cAAe,AACf,eAAgB,AAChB,cAAgB,CACjB","file":"home.vue","sourcesContent":["\n.home[data-v-4fb28d44] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.no-info[data-v-4fb28d44] {\n  padding: 100px 0;\n  text-align: center;\n  font-size: 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.no-info .no-data[data-v-4fb28d44] {\n    -ms-flex-item-align: center;\n        -ms-grid-row-align: center;\n        align-self: center;\n}\n.fade-enter-active[data-v-4fb28d44], .fade-leave-active[data-v-4fb28d44] {\n  transition: opacity .5s;\n}\n.fade-enter[data-v-4fb28d44], .fade-leave-to[data-v-4fb28d44] {\n  opacity: 0;\n}\n.page[data-v-4fb28d44] {\n  position: absolute;\n  width: 100%;\n  top: 470px;\n  z-index: 30;\n}\n.page .dots[data-v-4fb28d44] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n}\n.page .dots .dot-active[data-v-4fb28d44] {\n      display: inline-block;\n      width: 15px;\n      height: 15px;\n      background-color: #1da377;\n      border-radius: 8px;\n      margin-right: 10px;\n      cursor: pointer;\n}\n.page .dots .dot[data-v-4fb28d44] {\n      opacity: 0.2;\n}\n.activity-panel[data-v-4fb28d44] {\n  width: 1220px;\n  margin: 0 auto;\n}\n.activity-panel .box[data-v-4fb28d44] {\n    overflow: hidden;\n    position: relative;\n    z-index: 0;\n    margin-top: 25px;\n    box-sizing: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.14);\n    border-radius: 8px;\n    background: #fff;\n    box-shadow: 0 3px 8px -6px rgba(0, 0, 0, 0.1);\n}\n.activity-panel .content[data-v-4fb28d44] {\n    float: left;\n    position: relative;\n    box-sizing: border-box;\n    width: 25%;\n    height: 230px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    text-align: center;\n}\n.activity-panel .content[data-v-4fb28d44] ::before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    box-sizing: border-box;\n    border-left: 1px solid #f2f2f2;\n    border-left: 1px solid rgba(0, 0, 0, 0.1);\n    width: 100%;\n    height: 100%;\n    content: \"\";\n    pointer-events: none;\n}\n.activity-panel .i[data-v-4fb28d44] {\n    height: 200px;\n}\n.activity-panel .cover-link[data-v-4fb28d44] {\n    cursor: pointer;\n    display: block;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 4;\n    background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;\n}\n.activity-panel a[data-v-4fb28d44] {\n    color: #5079d9;\n    cursor: pointer;\n    transition: all .15s ease-out;\n    text-decoration: none;\n}\n.activity-panel a[data-v-4fb28d44]:hover {\n    box-shadow: inset 0 0 38px rgba(0, 0, 0, 0.08);\n    transition: all .15s ease;\n}\n.banner[data-v-4fb28d44], .banner span[data-v-4fb28d44], .banner div[data-v-4fb28d44] {\n  font-family: \"Microsoft YaHei\";\n  transition: all .3s;\n  transition-timing-function: linear;\n}\n.banner[data-v-4fb28d44] {\n  cursor: pointer;\n  perspective: 3000px;\n  position: relative;\n  z-index: 19;\n  margin: 0 auto;\n  width: 1220px;\n}\n.bg[data-v-4fb28d44] {\n  position: relative;\n  width: 1220px;\n  height: 500px;\n  margin: 20px auto;\n  background-size: 100% 100%;\n  border-radius: 10px;\n  transform-style: preserve-3d;\n  transform-origin: 50% 50%;\n  transform: rotateY(0deg) rotateX(0deg);\n}\n.bg div[data-v-4fb28d44] {\n    position: relative;\n    height: 100%;\n    width: 100%;\n}\n.img1[data-v-4fb28d44] {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  border-radius: 10px;\n}\n.img2[data-v-4fb28d44] {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  bottom: 5px;\n  left: 0;\n  background-size: 95% 100%;\n  border-radius: 10px;\n}\n.img3[data-v-4fb28d44] {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  border-radius: 10px;\n}\n.a[data-v-4fb28d44] {\n  z-index: 20;\n  transform: translateZ(40px);\n}\n.b[data-v-4fb28d44] {\n  z-index: 20;\n  transform: translateZ(30px);\n}\n.c[data-v-4fb28d44] {\n  transform: translateZ(0px);\n}\n.sk_item[data-v-4fb28d44] {\n  width: 170px;\n  height: 225px;\n  padding: 0 14px 0 15px;\n}\n.sk_item > div[data-v-4fb28d44] {\n    width: 100%;\n}\n.sk_item a[data-v-4fb28d44] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    transition: all .3s;\n}\n.sk_item a[data-v-4fb28d44]:hover {\n      transform: translateY(-5px);\n}\n.sk_item img[data-v-4fb28d44] {\n    width: 130px;\n    height: 130px;\n    margin: 17px 0;\n}\n.sk_item .sk_item_name[data-v-4fb28d44] {\n    color: #999;\n    display: block;\n    max-width: 100%;\n    _width: 100%;\n    overflow: hidden;\n    font-size: 12px;\n    text-align: left;\n    height: 32px;\n    line-height: 16px;\n    word-wrap: break-word;\n    word-break: break-all;\n}\n.sk_item .sk_item_price[data-v-4fb28d44] {\n    padding: 3px 0;\n    height: 25px;\n}\n.sk_item .price_new[data-v-4fb28d44] {\n    font-size: 18px;\n    font-weight: 700;\n    margin-right: 8px;\n    color: #f10214;\n}\n.sk_item .price_origin[data-v-4fb28d44] {\n    color: #999;\n    font-size: 12px;\n}\n.box[data-v-4fb28d44] {\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n  margin-top: 29px;\n  box-sizing: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.14);\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 3px 8px -6px rgba(0, 0, 0, 0.1);\n}\nul.box[data-v-4fb28d44] {\n  display: -ms-flexbox;\n  display: flex;\n}\nul.box li[data-v-4fb28d44] {\n    -ms-flex: 1;\n        flex: 1;\n}\nul.box li img[data-v-4fb28d44] {\n      display: block;\n      height: 200px;\n}\n.mt30[data-v-4fb28d44] {\n  margin-top: 30px;\n}\n.hot[data-v-4fb28d44] {\n  display: -ms-flexbox;\n  display: flex;\n}\n.hot > div[data-v-4fb28d44] {\n    -ms-flex: 1;\n        flex: 1;\n    width: 25%;\n}\n.floors[data-v-4fb28d44] {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.floors .imgbanner[data-v-4fb28d44] {\n    width: 50%;\n    height: 430px;\n}\n.floors .imgbanner .cover-link[data-v-4fb28d44] {\n      cursor: pointer;\n      display: block;\n      position: absolute;\n      top: 60px;\n      left: 0;\n      width: 50%;\n      height: 430px;\n      z-index: 4;\n      background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;\n}\n.floors .imgbanner .cover-link[data-v-4fb28d44]:hover {\n      box-shadow: inset 0 0 38px rgba(0, 0, 0, 0.08);\n      transition: all .15s ease;\n}\n.floors img[data-v-4fb28d44] {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n.more[data-v-4fb28d44] {\n  color: #5078df;\n  font-size: 16px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(409);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(239)("552d1e6b", content, true, {});

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [(!_vm.error) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "35vw"
    },
    attrs: {
      "element-loading-text": "加载中..."
    }
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('div', {
    ref: "bg",
    staticClass: "bg",
    on: {
      "mouseover": function($event) {
        return _vm.bgOver(_vm.$refs.bg)
      },
      "mousemove": function($event) {
        return _vm.bgMove(_vm.$refs.bg, $event)
      },
      "mouseout": function($event) {
        return _vm.bgOut(_vm.$refs.bg)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.bannerList), function(item, i) {
    return (i === _vm.mark) ? _c('div', {
      key: i,
      staticStyle: {
        "position": "absolute"
      },
      on: {
        "click": function($event) {
          return _vm.onBannerClick(item)
        },
        "mouseover": _vm.stopTimer,
        "mouseout": _vm.startTimer
      }
    }, [_c('img', {
      staticClass: "img1",
      attrs: {
        "src": item.pic
      }
    })]) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('ul', {
    staticClass: "dots"
  }, _vm._l((_vm.bannerList), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "dot-active",
      class: {
        'dot': i != _vm.mark
      },
      on: {
        "click": function($event) {
          return _vm.change(i)
        }
      }
    })
  }), 0)])]), _vm._v(" "), (_vm.headHealthList.length > 0) ? _c('div', {
    staticClass: "activity-panel"
  }, [_c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.headHealthList), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "content",
      on: {
        "click": function($event) {
          return _vm.linkTo(item)
        }
      }
    }, [_c('img', {
      staticClass: "i",
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "cover-link"
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.actList.length > 0) ? _c('section', {
    staticClass: "w mt30 clearfix"
  }, [_c('y-shelf', {
    attrs: {
      "title": "活动专区"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.onMore(5)
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.actList), function(item, i) {
    return _c('mall-goods', {
      key: i + 'key',
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.healthList.length > 0) ? _c('section', {
    staticClass: "w mt30 clearfix"
  }, [_c('y-shelf', {
    attrs: {
      "title": "健康专区"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.onMore(3)
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.healthList), function(item, i) {
    return _c('mall-goods', {
      key: i + 'key',
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.likeInfo.length > 0) ? _c('section', {
    staticClass: "w mt30 clearfix"
  }, [_c('y-shelf', {
    attrs: {
      "title": "热门榜单"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.onMore(2)
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.likeInfo), function(item, i) {
    return _c('mall-goods', {
      key: i + 'key',
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.bastList.length > 0) ? _c('section', {
    staticClass: "w mt30 clearfix"
  }, [_c('y-shelf', {
    attrs: {
      "title": "精品推荐"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.onMore(1)
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "imgbanner",
    on: {
      "click": function($event) {
        return _vm.linkTo(_vm.bastFirst)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.bastFirst.image),
      expression: "bastFirst.image"
    }]
  }), _vm._v(" "), _c('a', {
    staticClass: "cover-link"
  })]), _vm._v(" "), _vm._l((_vm.bastList), function(item, i) {
    return _c('mall-goods', {
      key: i + 'key',
      attrs: {
        "msg": item
      }
    })
  })], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.benefit.length > 0) ? _c('section', {
    staticClass: "w mt30 clearfix"
  }, [_c('y-shelf', {
    attrs: {
      "title": "为您推荐"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.onMore(4)
      }
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.benefit), function(item, i) {
    return _c('mall-goods', {
      key: i + 'key',
      attrs: {
        "msg": item
      }
    })
  }), 1)])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    },
    attrs: {
      "title": "通知",
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("首页已升级！XPay个人支付收款系统已上线，赶快去支付体验吧！")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("知道了")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/error.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！出错了...\n      ")])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.373edf55df130a4c95f9.js